import { flags, onFlagsChanged } from "@/config";
import { installDebugBridge } from "@/services/debug/debugBridge";
import { flightRecorder } from "@/services/debug/FlightRecorder";
import { store } from "@/store/store";
import { setRowRenderProbe } from "@/ui/rowRenderProbe";

/**
 * Wires the flight recorder's detail tier to debug mode, following the flag as the Debug Menu toggles it: store flush
 * counts, table-row probes, long-frame observation, and `window.__sbDebug`. Compute totals need no wiring; they are
 * always on.
 */
export function initializeFlightRecorder(): void {
  apply(flags.debugMode === true);
  onFlagsChanged((next) => apply(next.debugMode === true));
}

function apply(detailed: boolean): void {
  if (detailed === flightRecorder.isDetailed()) return;
  flightRecorder.setDetailed(detailed);
  store.observeFlushes(detailed ? (counts) => flightRecorder.recordFlush(counts) : null);
  setRowRenderProbe(detailed ? (rendered) => flightRecorder.countRow(rendered) : null);
  if (detailed) installDebugBridge();
}
